import './style.css';
import { useState } from 'react';
import { Button } from 'react-bootstrap';
import { Link, Navigate } from 'react-router-dom';
import Common from '../../../shared/Common';
import type { IUserSettingsChildProps } from '../UserSettings';

const Disable2fa = (props: IUserSettingsChildProps) => {
  const [formLoading, setFormLoading] = useState<boolean>(false);
  const [redirect, setRedirect] = useState<boolean>(false);
  const { setStatus, fetchUserDataTrigger, setFetchUserDataTrigger } = props;

  const disable2fa = async () => {
    setFormLoading(true);
    const requestOptions = {
      method: 'POST',
      body: JSON.stringify({}),
      headers: { 'Content-Type': 'application/json' },
    };
    const response = await Common.authorizedFetch('api/twoFactorAuthentication/disable2Fa', requestOptions);
    const data = await response.json();
    setFormLoading(false);
    if (!data.success) {
      setStatus({
        variant: 'error',
        status: data.errors,
        messageTime: Date.now(),
      });
    } else {
      setRedirect(true);
      setStatus({
        variant: 'success',
        status: data.informations,
        messageTime: Date.now(),
      });
      setFetchUserDataTrigger(fetchUserDataTrigger + 1);
    }
  };

  return (
    <>
      {redirect && <Navigate to={'/settings/user/2fa'} replace />}
      {Common.Ui.showLoadingSpinnerFixed(formLoading)}
      <h4>Wyłącz uwierzytelnienie dwuskładnikowe (2FA)</h4>
      <div className='alert alert-warning' role='alert'>
        <p>
          <strong>Ta akcja wyłącza uwierzytelnienie dwuskładnikowe 2FA.</strong>
        </p>
        <p>
          Wyłączenie 2FA nie zmienia kluczy wykorzysytwanych w aplikacji do uwierzytelnienia. Jeśli chesz zmienić klucze
          wykorzystywane w aplikacji powinieneś&nbsp;
          <Link to='/settings/user/2fa/generate-recovery-codes'>zresetować swoje klucze</Link>.
        </p>
      </div>
      <Button variant='danger' onClick={disable2fa} disabled={formLoading}>
        Wyłącz 2FA
      </Button>
    </>
  );
};

export default Disable2fa;
